<template>
	<my-dialog :visible.sync="showDialog" title="个人信息" dialog-type="form" :close-on-click-modal="false" @close="closeDialog">
		<div class="user-info-panel">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="姓名" prop="chName">
					<el-input v-model="editForm.chName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
					<el-input v-model="editForm.userName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="照片" prop="userImagePath">
					<el-upload
						v-if="showImg.photo === ''"
						ref="upload"
						class="input_200px"
						:headers="headers"
						:data="editPhoto"
						:multiple="false"
						:action="action2"
						:on-success="progress"
						:limit="1"
						list-type="picture-card"
						:auto-upload="true"
						:show-file-list="false"
					>
						<template #default>
							<i class="el-icon-plus"></i>
						</template>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img class="up_img" :src="showImg.photo" />
							<i class="el-icon-delete ui_delete" @click="deleteImg(1)"></i>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="签名" prop="signImg">
					<el-upload
						v-if="showImg.sign === ''"
						ref="upload"
						class="input_200px"
						:headers="headers"
						:data="editPhoto"
						:multiple="false"
						:action="action1"
						:on-success="progress"
						:limit="1"
						list-type="picture-card"
						:auto-upload="true"
						:show-file-list="false"
					>
						<template #default>
							<i class="el-icon-plus"></i>
						</template>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img class="up_img" :src="showImg.sign" />
							<i class="el-icon-delete ui_delete" @click="deleteImg(2)"></i>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-radio-group v-model="editForm.gender" disabled class="input_200px">
						<el-radio-button :label="1">男</el-radio-button>
						<el-radio-button :label="0">女</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="工号" prop="workerNo">
					<el-input v-model="editForm.workerNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="卡号" prop="cardNo">
					<el-input v-model="editForm.cardNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="idCardNo">
					<el-input v-model="editForm.idCardNo" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="部门" prop="deptCode">
					<el-input v-model="editForm.dept" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-input v-model="editForm.roleName" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="人员职级" prop="userRank">
					<el-input v-model="editForm.userRank" disabled class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="人员类别" prop="userType">
					<el-select v-model="editForm.userType" disabled size="small" filterable :clearable="true" class="input_200px">
						<el-option v-for="item in userTypeList" :key="item.dicCode" :label="item.dicText" :value="item.dicCode"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<el-input clearable v-model="editForm.phone" class="input_200px" size="small"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="comment">
					<el-input v-model="editForm.comment" disabled :rows="4" class="input_200px" type="textarea"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { GetUserInfoDetail, UpdateUserPhone } from "../../../api/userApi.js";
import { GetDicDataListByParentCode } from "../../../api/dicDataApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			saveloading: false,
			editForm: {},
			rules: {},
			userTypeList: [],
			hideUpload: false,
			limitCount: 1,
			headers: {
				Authorization: "Bearer " + localStorage.getItem("logintoken")
			},
			action1: "/api/sysConfig/User/UpdateUserSignature",
			action2: "/api/sysConfig/User/UpdateUserPhoto",
			// 签名、人员照片
			editPhoto: {
				KeyId: ""
			},

			showImg: {
				photo: "",
				sign: ""
			}
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {},
	methods: {
		// 显示
		showUserInfoDialog(data) {
			this.showDialog = true;
			this.editPhoto.KeyId = data.keyId;
			this.getUserType();
			this.getUserInfoDetail();
		},

		// 点击保存
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.updateUserPhone();
				} else {
					return false;
				}
			});
		},

		// 删除图片
		deleteImg(type) {
			if (type === 1) {
				this.showImg.photo = "";
			} else {
				this.showImg.sign = "";
			}
		},

		// 获取个人信息详情
		getUserInfoDetail() {
			let parameter = {
				keyId: this.editPhoto.KeyId
			};
			GetUserInfoDetail(parameter)
				.then((res) => {
					if (res.code == 1) {
						this.editForm = res.data;
						if (res.data.photoImg === "") {
							this.showImg.photo = "";
						} else {
							this.showImg.photo = "data:image/png;base64," + res.data.photoImg;
						}
						if (res.data.signImg === "") {
							this.showImg.sign = "";
						} else {
							this.showImg.sign = "data:image/png;base64," + res.data.signImg;
						}
						this.showDialog = true;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 获取人员类型
		getUserType() {
			let parmter = {
				parentCode: "UserType"
			};
			GetDicDataListByParentCode(parmter)
				.then((res) => {
					if (res.code == 1) {
						this.userTypeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 更新电话号码
		updateUserPhone() {
			this.saveloading = true;
			let param = {
				keyId: this.editForm.keyId,
				phone: this.editForm.phone
			};
			UpdateUserPhone(param)
				.then((res) => {
					this.saveloading = false;
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "保存成功！"
						});
						this.showDialog = false;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.saveloading = false;
					this.$message.error("保存失败，请稍后再试！");
				});
		},

		progress(event, file) {
			this.getUserInfoDetail();
		},

		// 关闭
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss">
.user-info-panel {
	padding: 8px 10px 0;
}

::v-deep .demo-form-inline {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	row-gap: 8px;
}

::v-deep .demo-form-inline .el-form-item {
	margin-bottom: 8px;
	width: calc(50% - 10px);
}

::v-deep .demo-form-inline .el-form-item__content {
	width: calc(100% - 8.75rem);
}

::v-deep .input_200px {
	width: 100%;
}

.up_img {
	width: 100px;
	height: 100px;
	position: relative;

	.ui_delete {
		position: absolute;
		font-size: 20px;
		color: #ff0000;
		top: 0px;
		right: 0px;
	}
}

::v-deep .el-upload--picture-card {
	width: 100px;
	height: 100px;
	line-height: 100px;
}

::v-deep .el-input.is-disabled .el-input__inner {
	background: none;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
	background: none;
}

::v-deep .el-input__inner {
	background: #ffffff;
	color: #606266;
	border: 0.0625rem solid #cfcfcf;
}
</style>
